
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'

import Vue from 'vue'

export default Vue.extend({
  name: 'JcdcExportBtn',
  components: {
    JcdcBtn,
  },
  props: {
    // Button
    btnText: { type: String, required: true },
    btnIcon: { type: String, required: true },
    align: {
      type: String,
      default: 'left',
      validator(value: string) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      },
    },
    secondary: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
})
